import { Alert, Button, Form, Input, Space } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ApiService from "../../core/service/api-service";
import { useModal } from "../../core/context/ModalContext";
import { useUser } from "../../core/context/UserContext";

/** Oturumu açık kullanıcının kendi parolasını değiştirdiği form. Profil menüsünden açılır. */
export default function ChangePasswordModal() {
    const { t } = useTranslation();
    const { closeModal } = useModal();
    const { setToken } = useUser();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);

    const handleSubmit = async (values) => {
        setSaving(true);
        try {
            const response = await ApiService.User.ChangePassword({
                currentPassword: values.currentPassword,
                newPassword: values.newPassword
            });

            if (response.success) {
                // Parola değişince kullanıcının önceki token'ları elenir; taze token'ı saklamazsak
                // bir sonraki istekte kendi işlemimiz yüzünden oturum düşer.
                setToken(response.data.access_token);
                toast.success(t('Your password has been changed'));
                closeModal();
            }
        } finally {
            setSaving(false);
        }
    };

    return (
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Alert
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
                message={t('Changing your password signs out your other sessions')}
            />

            <Form.Item
                name="currentPassword"
                label={t('Current Password')}
                rules={[{ required: true, message: t('Please enter your current password') }]}
            >
                <Input.Password autoComplete="current-password" />
            </Form.Item>

            <Form.Item
                name="newPassword"
                label={t('New Password')}
                rules={[
                    { required: true, message: t('Please enter your new password') },
                    { min: 8, message: t('Password must be at least 8 characters.') }
                ]}
            >
                <Input.Password autoComplete="new-password" />
            </Form.Item>

            <Form.Item
                name="newPasswordRepeat"
                label={t('New Password (Repeat)')}
                dependencies={['newPassword']}
                rules={[
                    { required: true, message: t('Please repeat your new password') },
                    ({ getFieldValue }) => ({
                        validator: (_, value) =>
                            !value || getFieldValue('newPassword') === value
                                ? Promise.resolve()
                                : Promise.reject(new Error(t('Passwords do not match')))
                    })
                ]}
            >
                <Input.Password autoComplete="new-password" />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                <Space>
                    <Button onClick={closeModal}>{t('Cancel')}</Button>
                    <Button type="primary" htmlType="submit" loading={saving}>
                        {t('Change Password')}
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    );
}
